import React, { useState, useEffect } from 'react'
import { DashboardKorat } from './pages/DashboardKorat'
import {
  LoginPage,
  PersonnelPage,
  FinancialPage,
  HealthPage,
  VulnerablePage,
  StrategicPage,
  RehabPage,
  PopulationPage,
} from './pages'
import { BedriddenPatientsDashboard } from './pages/BedriddenPatientsDashboard'
import { BedriddenPatientsList } from './pages/BedriddenPatientsList'
import { BedriddenPatientsForm } from './pages/BedriddenPatientsForm'
import { ErrorBoundary, ErrorFallback } from './shared/components'

function App() {
  const [currentPage, setCurrentPage] = useState('dashboard')

  // Check authentication
  const isAuthenticated = () => {
    return !!localStorage.getItem('access_token')
  }

  // Simple hash-based routing
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1) || 'dashboard'

      // If not authenticated and trying to access protected page, redirect to login
      if (!isAuthenticated() && hash !== 'login') {
        window.location.hash = 'login'
        setCurrentPage('login')
        return
      }

      setCurrentPage(hash)
    }

    window.addEventListener('hashchange', handleHashChange)
    handleHashChange() // Initial load

    return () => window.removeEventListener('hashchange', handleHashChange)
  }, [])

  // Expose navigation function globally for ModuleTiles
  useEffect(() => {
    window.navigateTo = (page) => {
      window.location.hash = page
    }
  }, [])

  const renderPage = () => {
    // Extract patient ID from hash for edit mode
    const hashParts = currentPage.split('/')

    switch (currentPage) {
      case 'login':
        return <LoginPage />
      case 'personnel':
        return <PersonnelPage />
      case 'financial':
        return <FinancialPage />
      case 'health':
        return <HealthPage />
      case 'vulnerable':
        return <VulnerablePage />
      case 'strategic':
        return <StrategicPage />
      case 'rehab':
        return <RehabPage />
      case 'population':
        return <PopulationPage />
      case 'bedridden':
        return <BedriddenPatientsDashboard />
      case 'bedridden-patients':
        return <BedriddenPatientsList />
      case 'bedridden-patients-new':
        return <BedriddenPatientsForm />
      default:
        // Handle dynamic routes like bedridden-patients/{id}/edit
        if (hashParts[0] === 'bedridden-patients' && hashParts[2] === 'edit') {
          const patientId = parseInt(hashParts[1])
          return <BedriddenPatientsForm patientId={patientId} />
        }
        return <DashboardKorat />
    }
  }

  return (
    <ErrorBoundary
      fallback={
        <ErrorFallback
          title="เกิดข้อผิดพลาดในการแสดงผล"
          message="ขออภัย ไม่สามารถโหลดหน้านี้ได้ในขณะนี้ กรุณาลองใหม่อีกครั้งหรือกลับไปหน้าหลัก"
          showDetails={true}
        />
      }
      onError={(error, errorInfo) => {
        // Log to console in development
        if (import.meta.env.DEV) {
          console.error('App Error:', error, errorInfo)
        }
        // TODO: Send to error tracking service (e.g., Sentry) in production
      }}
    >
      {renderPage()}
    </ErrorBoundary>
  )
}

export default App
